import { Injectable } from '@angular/core';
import { observable, action } from 'mobx-angular';
import { AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { DataService } from 'src/app/services/data.service';
import { pushToArray, pushToObject, groupBy, MappingService, academicYearObj } from 'src/app/services/mapping.service';
import { ACADEMIC_YEAR_STATUS, APPS, PROGRAM_OPTION_OBJ } from 'src/app/dummy/app';

@Injectable({
    providedIn: 'root'
})
export class List {
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable data: Array<any> = [];
    @observable items: any[] = [];
    @observable groups: any[] = [];
    @observable empty: boolean = false;

    subscribe: any = null;
    constructor(private ds: DataService) { }

    @action
    async fetchSelected(ref: AngularFirestoreCollection, itemKey) {
        const doc = await ref.doc(itemKey).get().toPromise();
        return pushToObject(doc);
    }

    @action
    async fetchItemRef(ref: any) {
        const doc = await ref.get();
        return doc.data()
    }

    @action
    async fetchList(ref: AngularFirestoreCollection) {
        this.process = true;
        const docs = await ref.get().toPromise();
        this.process = false;
        return pushToArray(docs);
    }

    @action
    fetchSubscribe(ref: AngularFirestoreCollection, callback) {
        this.process = true;
        ref.valueChanges().subscribe(doc => {
            this.process = false;
            callback(doc)
        })
    }

    async fetchDoc(ref: AngularFirestoreDocument) {
        this.process = true;
        const docs = await ref.get().toPromise();
        this.process = false;
        return pushToObject(docs);
    }


    @action
    dispost() {
        this.data = [];
        this.items = [];
        if (this.subscribe) this.subscribe.unsubscribe()
    }

    @action
    fetchData(ref: AngularFirestoreCollection) {
        this.loading = true;
        this.subscribe = ref.valueChanges().subscribe(docs => {
            this.data = docs;
            this.empty = docs.length === 0;
            this.loading = false;
        })
    }

    @action
    fetchGroupData(ref: AngularFirestoreCollection, groupField: string, orderBy) {
        this.loading = true;
        this.subscribe = ref.valueChanges().subscribe(docs => {
            this.data = docs;
            this.groups = groupBy(docs, groupField, orderBy);
            this.empty = docs.length === 0;
            this.loading = false;
        })
    }

    @action
    save(ref: AngularFirestoreCollection, item: any, callback) {
        this.process = true;
        ref.doc(item.key).set(item).then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    saveBatch(batch: firebase.firestore.WriteBatch, callback) {
        this.process = true;
        batch.commit().then(() => {
            callback(true, null);
        }).catch((error) => {
            alert(error);
            callback(false, error)
        }).finally(() => {
            this.process = false;
        })
    }

    @action
    search(search) {
        if (search)
            return this.ds.subjectSearchRef(search).valueChanges();
        return this.ds.subjectRef(ref => ref.orderBy('name').limit(APPS.SIZE)).valueChanges();
    }

    @action
    delete(ref: any, item: any, callback) {
      this.process = true;
      ref.doc(item.key).delete().then(() => {
        this.process = false;
        callback(true, null);
      }).catch(error => {
        this.process = false;
        callback(false, error);
      })
    }

    @action
    async activeTerm(item: any, user: any, callback) {
      const batch = this.ds.batch();
      this.loading = true;
      const { key, termType, schoolKey } = item

      const envDoc = await this.ds.storeDocRef(schoolKey).collection("academic_environment").doc("academic_environment").get().toPromise();
      const envData = MappingService.pushToObject(envDoc)
      const { year, term } = envData
      const oldAcademicYear = termType.key === PROGRAM_OPTION_OBJ.yearBase.key ? year : term

      const schoolRef = this.ds.firestore().collection("organizations").doc(schoolKey)
      const yearRef = this.ds.academicYearFireRef()

      let data = null;
      if (termType.key === PROGRAM_OPTION_OBJ.yearBase.key) {
        data = {
          year: academicYearObj(item)
        }
      } else {
        data = {
          term: academicYearObj(item)
        }
      }

      //CLOSE ACADEMIC YEAR
      const closeData = {
        yearStatus: ACADEMIC_YEAR_STATUS[2],
        closed_at: new Date(),
        closed_by: user.key,
      }
      // batch.update(yearRef.doc(oldAcademicYear.key), { ...closeData })
      // batch.update(schoolRef.collection("academic_year").doc(oldAcademicYear.key), { ...closeData })

      //NEW ACADEMIC YEAR
      batch.update(schoolRef.collection("academic_environment").doc("academic_environment"), { ...data })

      const activeData = {
        yearStatus: ACADEMIC_YEAR_STATUS[1],
        active_at: new Date(),
        active_by: user.key,
      }

      batch.update(yearRef.doc(key), { ...activeData })
      batch.update(schoolRef.collection("academic_year").doc(key), { ...activeData })

      batch.commit().then(() => {
        this.loading = false;
        callback(true, null);
      }).catch(error => {
        this.loading = false;
        callback(false, error);
      })
    }

  }
